<template>
  <div>
    <div
      class="content-wrapper padding-videointerview"
      :class="{
        'content-wrapper--videoresume': isVideoresume,
        'content-wrapper--videoresume-end': isVideoresumeEnd
      }"
    >
      <div class="content content_page">
        <div class="landing">
          <router-view class="landing_content" />
        </div>
      </div>
    </div>

    <template v-if="!isOpenRegistration">
      <vfooter
        type="landing"
        :background="!isVideoresume ? '#e5e5e5' : '#fafafa'"
        :company_language="company_language"
        :is-videoresume="isVideoresume"
      />
    </template>

    <template v-else>
      <vfooter-landing type="landing" :company_language="company_language" :is-videoresume="isVideoresume" />
    </template>
  </div>
</template>

<script>
// import vheader from '@/routes_new/outer/components/vheader.vue'
import vfooter from '@/routes_new/outer/components/vfooter.vue';
import vfooterLanding from '@/routes_new/outer/components/vfooterLanding.vue';
import { mapState } from 'vuex';

export default {
  name: 'InterviewLanding',

  components: {
    // vheader,
    vfooter,
    vfooterLanding
  },

  computed: {
    ...mapState('interview', ['company_language']),
    // vacancy_country() {
    //   return this.$store.getters['interview/country'];
    // },

    // company_language() {
    //   return this.$store.getters['interview/company_language'];
    // },

    isOpenRegistration() {
      return this.$route.name === 'open-registration';
    },

    landing() {
      return this.$store.getters['landing/item'];
    },

    isVideoresume() {
      if (!this.landing) {
        return false;
      }
      return this.landing.is_videoresume;
    },

    isVideoresumeEnd() {
      return this.$route.name === 'interview-videoresume-feedback';
    }
  }
};
</script>

<style lang="scss" scoped>
.landing {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 25px;

  .landing_content {
    box-sizing: border-box;
  }
}

.content_page {
  @media (max-width: 768px) {
    background: white;
  }
}

.content-wrapper--videoresume {
  background: #fafafa;

  .content {
    max-width: 912px;
    box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.05);
    border-radius: 4px;
  }

  &.content-wrapper--videoresume-end {
    .content {
      max-width: 668px;
      padding: 0;
    }
  }
}
</style>
